import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import DigitalColorMeter from '@/components/sidebar/DigitalColorMeter'
import Gallery from '@/components/sidebar/Gallery'
import type { RootState } from '@/store'
import type { LABColor } from '@/store/appSlice'
import { DEHAZE_INCLUDED_PATHS } from '@/utils/constants'

import Dehazing from './Dehazing'

const Sidebar = () => {
  const location = useLocation()
  const labColor = useSelector<RootState, LABColor>(
    (store) => store.app.selectedColor,
  )

  return (
    <Box
      display="flex"
      flexDirection="column"
      flexGrow="1"
      overflow="auto"
      component="aside"
    >
      <Gallery />
      <DigitalColorMeter labColor={labColor} />
      {DEHAZE_INCLUDED_PATHS.includes(location?.pathname || '') && <Dehazing />}
    </Box>
  )
}

export default Sidebar
